
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Nashikcabservice() {



    const cardData =
    {
        keyword: 'Nashik Cab Service',
        heading: 'S9 Travels: Nashik Cab Service',
        headingDescription: 'S9 Travels offers reliable, affordable, and comfortable Nashik cab services tailored for local travel, outstation trips, and airport transfers. Whether you are heading to Mumbai, Pune, Shirdi, or exploring Nashik is vineyards and temples, our wide range of well-maintained cabs — from sedans and SUVs to luxury cars — ensures a smooth, safe, and stress-free ride. With professionally trained drivers, 24/7 customer support, on-time pickups, and flexible booking options, S9 Travels is your trusted partner for all your cab booking needs in Nashik. Book your Nashik taxi today for a hassle-free journey backed by comfort, convenience, and reliability.',

        top: 'Top Places to Visit in Nashik with S9 Travels',

"topPlaces": [
    {
      "title": "Sula Vineyards",
      "description": "Sula Vineyards is India's most famous winery, offering vineyard tours, wine tastings, and a beautiful landscape. It is a must-visit for wine enthusiasts."
    },
    {
      "title": "Trimbakeshwar Temple",
      "description": "One of the twelve Jyotirlingas of Lord Shiva, Trimbakeshwar Temple is a highly revered Hindu pilgrimage site known for its spiritual significance and ancient architecture."
    },
    {
      "title": "Panchavati",
      "description": "Panchavati is a sacred area in Nashik with religious sites like Sita Gufa, Kalaram Temple, and Ramkund, associated with the Ramayana."
    },
    {
      "title": "Pandav Leni Caves",
      "description": "These ancient rock-cut caves date back to the 1st century BCE and feature Buddhist sculptures and inscriptions. They offer a historical and scenic experience."
    },
    {
      "title": "Anjneri Hill",
      "description": "Believed to be the birthplace of Lord Hanuman, Anjneri Hill is a popular trekking spot with breathtaking views and spiritual significance."
    },
    {
      "title": "Someshwar Waterfall",
      "description": "Located near the Someshwar Temple, this picturesque waterfall is a serene spot, especially during the monsoon season."
    },
    {
      "title": "Dudhsagar Falls (Nashik)",
      "description": "Not to be confused with Goa’s Dudhsagar Falls, this smaller yet scenic waterfall is a great picnic spot near Nashik."
    },
    {
      "title": "Harihar Fort",
      "description": "A thrilling trekking destination, Harihar Fort features a steep, rock-cut staircase leading to mesmerizing views from the top."
    },
    {
      "title": "Saptashrungi Devi Temple",
      "description": "Situated on a hill, this revered temple dedicated to Goddess Saptashrungi offers breathtaking views and is an important pilgrimage site."
    },
    {
      "title": "Coin Museum",
      "description": "India’s only museum dedicated to coins, showcasing the history of Indian currency with rare coin collections and exhibits."
    }
],

"services": [
  {
    "name": "Nashik Cab Service",
    "description": "S9 Travels offers trusted Nashik cab services for city travel, outstation trips, and airport transfers. Enjoy a smooth ride with our trained drivers and well-maintained vehicles."
  },
  {
    "name": "Book Nashik Taxi Online",
    "description": "Book a taxi in Nashik online easily with S9 Travels. Whether for local travel or long-distance rides, our streamlined booking ensures instant confirmation and dependable service."
  },
  {
    "name": "Affordable Nashik Taxi Fare",
    "description": "Get pocket-friendly Nashik taxi fares without compromising on comfort or service. Choose from a fleet of AC cabs, sedans, and SUVs with transparent pricing."
  },
  {
    "name": "Private Cab for Nashik Sightseeing",
    "description": "Explore Nashik’s top attractions like Sula Vineyards, Trimbakeshwar Temple, and Panchavati in a private cab. Enjoy flexible itineraries and personalized taxi tours."
  },
  {
    "name": "Comfortable Taxi Service in Nashik",
    "description": "Travel comfortably with our Nashik taxi service. Our clean cars and courteous drivers ensure a safe and relaxing experience across the city and outskirts."
  },
  {
    "name": "Nashik One-Way and Round-Trip Cabs",
    "description": "Choose flexible travel options with our one-way or round-trip Nashik cabs. Ideal for airport transfers, outstation trips, or return journeys from Nashik."
  },
  {
    "name": "Luxury Cab Hire in Nashik",
    "description": "Book a luxury cab in Nashik for a premium experience. Perfect for business travel, VIP guests, or special events with plush seating and high-end comfort."
  },
  {
    "name": "Group Cab Booking in Nashik",
    "description": "Travel with your family or team using our spacious group cabs in Nashik. Ideal for events, corporate travel, or religious tours with ample luggage space."
  },
  {
    "name": "Nashik Pilgrimage Taxi Services",
    "description": "Visit famous pilgrimage spots like Trimbak, Saptashrungi, and Muktidham in a dedicated pilgrimage cab. Safe, spiritual, and comfortable travel guaranteed."
  },
  {
    "name": "24/7 Nashik Cab Booking Support",
    "description": "Need a cab in Nashik at odd hours? Our 24/7 customer support and real-time taxi tracking make your booking experience convenient and worry-free."
  }
],
  "tableData": [
    ["Nashik Cab Service", "Book Nashik Taxi"],
    ["Affordable Nashik Cab", "Private Taxi for Nashik Sightseeing"],
    ["Comfortable Taxi Service in Nashik", "Nashik One-Way or Round Trip Taxi"],
    ["Luxury Taxi for Nashik Trip", "Group Travel in Nashik Cabs"],
    ["Nashik Pilgrimage Tour by Taxi", "Convenient Nashik Taxi Booking"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of timely travel. Whether you're traveling to or from Nashik, we ensure prompt pickups and smooth rides. Our drivers are punctual and committed to making sure you reach your destination on time, every time."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the ideal vehicle for your Nashik trip. With comfortable seating, air conditioning, and ample space for luggage, you can enjoy a relaxing and stress-free ride. Whether you're traveling solo or with family and friends, you’ll experience comfort throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced, professional, and familiar with the best routes to and from Nashik. They are courteous, knowledgeable, and committed to ensuring a smooth and safe journey. You can relax and enjoy the ride with complete peace of mind."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Nashik cab service. You’ll receive a detailed breakdown of all costs upfront with no hidden charges, allowing you to plan your travel budget comfortably."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our Toyota Innova vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking. You can rest assured that your journey to or from Nashik will be secure and comfortable."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7, so you can travel to or from Nashik at any time. Whether it’s early in the morning or late at night, we will ensure your ride is ready. Our customer service team is available around the clock to assist you with your bookings."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Nashik cab service is easy and convenient with S9 Travels. You can book online through our website or mobile app, or contact our customer service team for personalized assistance in reserving your ride."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your journey to or from Nashik. Whether you need additional stops along the way or have specific preferences, we tailor the trip to suit your needs, ensuring a personalized and enjoyable experience."
  }
]






    }



    const faqData = [
        [
          {
            question: 'How can I book a cab for Nashik with S9 Travels?',
            answer: 'Booking a cab for Nashik is easy! You can book your ride online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Nashik travel?',
            answer: 'We offer a variety of vehicles, including the spacious Toyota Innova, ideal for families, groups, or passengers with extra luggage. Choose the vehicle that best suits your needs for a comfortable journey to or from Nashik.'
          },
          {
            question: 'Are the drivers experienced for Nashik travel?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes to and from Nashik, ensuring a smooth, safe, and timely journey.'
          },
          {
            question: 'What payment options are available for booking a cab to or from Nashik?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and secure online payments through our mobile app, making it easy and convenient to pay for your ride.'
          },
          {
            question: 'Can I book a round trip to Nashik?',
            answer: 'Yes, you can book a round trip. Just provide us with your return details, and we’ll ensure your ride back from Nashik is as smooth and timely as your trip there.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip to Nashik?',
            answer: 'Any extra charges for detours or waiting time will be communicated to you upfront, ensuring full transparency in the pricing structure.'
          },
          {
            question: 'Can I make additional stops on the way to or from Nashik?',
            answer: 'Yes, you can request additional stops. Please inform us during the booking process, and we’ll accommodate your requests for detours or stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab to Nashik?',
            answer: 'The Toyota Innova offers plenty of space for standard luggage. If you have more luggage or special requirements, please let us know during booking, and we’ll make the necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Nashik?',
            answer: 'Yes, we offer corporate travel services to and from Nashik, ensuring a professional and comfortable journey for business travelers with timely pickups and drop-offs.'
          },
          {
            question: 'Why should I choose S9 Travels for my Nashik cab booking?',
            answer: 'S9 Travels provides a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey to or from Nashik.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rahul Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I used S9 Travels for a trip to Nashik, and it was an excellent experience. The driver was punctual, the vehicle was clean and spacious, and the overall journey was smooth and comfortable. Highly recommended for anyone traveling to Nashik!”'
        },
        {
          name: 'Mrs. Neha Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made our trip to Nashik so easy and stress-free. The car was well-maintained, and the driver was courteous and professional. I’ll definitely use their services again for future trips to Nashik.”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Nashik Cab Service – S9 Travels",
    "image": "https://s9travels.com/images/keyword/nashik-cab-service.jpg",
    "description":
      "S9 Travels provides reliable and affordable cab services in Nashik for local, outstation, and airport transfers. Choose from AC Hatchback, Sedan, SUV & Innova Crysta for business trips, pilgrimages, or family tours with 24/7 support and professional drivers.",
    "brand": { "@type": "Brand", "name": "S9 Travels" },
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "8421"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "999",
      "availability": "https://schema.org/InStock",
      "url": "https://s9travels.com/nashik-cab-service"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Which cab services are available in Nashik with S9 Travels?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "S9 Travels offers all types of Nashik cab services including local city rides, outstation trips to Pune, Mumbai, Shirdi, Aurangabad, and airport transfers. You can choose Hatchback, Sedan, SUV or Innova Crysta as per your comfort and budget."
        }
      },
      {
        "@type": "Question",
        "name": "What are the charges for Nashik cab booking?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Local Nashik cab service starts at ₹999 for 8 hours/80 km, while outstation trips are priced from ₹12 per km depending on the vehicle type. All prices are transparent with no hidden charges."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide airport transfer services from Nashik?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, S9 Travels provides pickup and drop cabs from Nashik to Mumbai Airport, Pune Airport, and Shirdi Airport. Our airport taxi services ensure on-time pickup and safe travel 24x7."
        }
      },
      {
        "@type": "Question",
        "name": "Are your cabs sanitized and safe for family travel?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Absolutely. All S9 Travels cabs in Nashik are sanitized regularly and driven by verified, experienced chauffeurs. We ensure clean interiors, AC comfort, and full safety for families and senior citizens."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "S9 Travels",
    "image": "https://s9travels.com/images/logo.png",
    "url": "https://s9travels.com/",
    "telephone": "+91 7090759555",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Wakad Road, Pimpri-Chinchwad",
      "addressLocality": "Nashik",
      "addressRegion": "Maharashtra",
      "postalCode": "422001",
      "addressCountry": "IN"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "8421"
    },
    "openingHours": "Mo-Su 00:00-23:59",
    "areaServed":
      "Nashik, Mumbai, Pune, Shirdi, Aurangabad, Igatpuri, Sinnar, Malegaon, Trimbakeshwar"
  };





      
      


    return (
        <div>
   
    <Helmet>
      {/* ✅ Title */}
      <title>
        Nashik Cab Service | Local, Outstation & Airport Taxi – S9 Travels
      </title>

      {/* ✅ Meta Description */}
      <meta
        name="description"
        content="Book reliable Nashik cab service with S9 Travels for local sightseeing, outstation trips, and airport transfers. Choose Hatchback, Sedan, SUV & Innova Crysta with 24/7 support, professional drivers, and AC comfort."
      />

      {/* ✅ Meta Keywords */}
      <meta
        name="keywords"
        content="Nashik Cab Service, Taxi in Nashik, Cab Booking Nashik, Outstation Cab Nashik, Nashik to Mumbai Cab, Nashik to Pune Cab, Airport Taxi Nashik, Nashik Innova Crysta Cab, Local Cab Nashik, S9 Travels Nashik"
      />

      {/* ✅ Canonical URL */}
      <link rel="canonical" href="https://s9travels.com/nashik-cab-service" />

      {/* ✅ Structured Data */}
      <script type="application/ld+json">{JSON.stringify(productSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>

      {/* ✅ Open Graph */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Nashik Cab Service | Local & Outstation Taxi | S9 Travels"
      />
      <meta
        property="og:description"
        content="Book AC cab in Nashik for local, outstation & airport travel. S9 Travels offers 24x7 service with professional drivers and clean vehicles."
      />
      <meta
        property="og:image"
        content="https://s9travels.com/images/keyword/nashik-cab-service.jpg"
      />
      <meta property="og:url" content="https://s9travels.com/nashik-cab-service" />
      <meta property="og:site_name" content="S9 Travels" />

      {/* ✅ Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Nashik Cab Service | 24x7 Local & Outstation Taxi | S9 Travels"
      />
      <meta
        name="twitter:description"
        content="S9 Travels provides 24/7 cab services in Nashik. Clean AC cars, professional drivers, airport transfers & outstation cabs at affordable prices."
      />
      <meta
        name="twitter:image"
        content="https://s9travels.com/images/keyword/nashik-cab-service.jpg"
      />
    </Helmet>

 
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/95.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Nashikcabservice;